import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
    import { IHotel } from '@entities/hotel';
    import FilterListRender from '@ve/components/filters/common/components/FilterListRender/FilterListRender.vue';
    import FiltersListSection from '@ve/components/searchFilters/filterList/desktop/FiltersListSection.vue';
    import { restTypeFilterMethods } from '../../lib/RestTypeFilterMethods';
    import useFilterHotelsModel from '../../lib/useFilterHotelsModel';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'DesktopRestTypeFilter',
  props: {
    allHotels: null,
    filteredHotels: null,
    visibleCounter: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
        allHotels: IHotel[];
        filteredHotels: IHotel[];
        visibleCounter: boolean;
    }

    

    const { restTypeFilter } = useFilterHotelsModel();

    const isSomeHotelHasRestType = computed(() => restTypeFilterMethods.isSomeHotelHasRestType(props.allHotels));


return { __sfc: true,props, restTypeFilter, isSomeHotelHasRestType, FilterListRender, FiltersListSection, restTypeFilterMethods }
}

})